import React from 'react';
import PropTypes from 'prop-types';

function BuyerInfo(props) {
  const {buyerInfo, title} = props;

  function formatBuyerName(buyerInfo = {}) {
    const { firstNm1, firstNm2, lastNm1, coBusNm } = buyerInfo;

    const parts = [firstNm1, firstNm2, lastNm1]
      .filter(Boolean)
      .map(name => name.trim());

    if (parts.length > 0) {
      return parts.join(' ');
    }

    return coBusNm?.trim() || '';
  }


  return(
    <section className="fmc-global-attribute-bar fmc-global-attribute-bar--vr-md fmc-px-3 fmc-pb-3-sm fmc-py-3-md fmc-py-3-lg fmc-py-3-xl fds-color__bg--white">
    <div className="fds-weight--bold">{title}</div>
    <div className="fds-layout-grid p-0">
      <div className="fds-layout-grid__inner p-0">
        <div className="fds-layout-grid__cell--span-2">Name:</div>
        <div className="fds-layout-grid__cell--span-10">
          {formatBuyerName(buyerInfo)}
        </div>
      </div>
    </div>
    <div className="fds-layout-grid p-0">
      <div className="fds-layout-grid__inner p-0">
        <div className="fds-layout-grid__cell--span-2">Address:</div>
        <div className="fds-layout-grid__cell--span-4"> {buyerInfo?.addrLine1Tx?.trim() }
        {buyerInfo?.addrLine2Tx && (<><br/>{buyerInfo?.addrLine2Tx?.trim()}</>)}
        {(buyerInfo?.cityNm || buyerInfo?.stAbbrCd || buyerInfo?.postCd) && (<br/>)}
        {buyerInfo?.cityNm?.trim()}{buyerInfo?.stAbbrCd && `, ${buyerInfo?.stAbbrCd?.trim()}`}{buyerInfo?.postCd && ` ${buyerInfo?.postCd?.trim()}`}</div>
        <div className="fds-layout-grid__cell--span-1">Employer: </div>
        <div className="fds-layout-grid__cell--span-5">{buyerInfo?.emplrNm?.trim() }</div>
      </div>
    </div>
    <div className="fds-layout-grid p-0">
      <div className="fds-layout-grid__inner p-0">
        <div className="fds-layout-grid__cell--span-2">Phone:</div>
        <div className="fds-layout-grid__cell--span-4">{buyerInfo?.phoneNumber?.trim()}</div>
        <div className="fds-layout-grid__cell--span-1">Phone:</div>
        <div className="fds-layout-grid__cell--span-5">{buyerInfo?.empPh?.trim()}</div>
      </div>
    </div>
  </section>
  );
}

BuyerInfo.propTypes = {
  buyerInfo: PropTypes.shape({
    firstNm1 : PropTypes.string,
    firstNm2 : PropTypes.string,
    lastNm1 : PropTypes.string,
    coBusNm : PropTypes.string,
    addrLine1Tx : PropTypes.string,
    addrLine2Tx : PropTypes.string,
    cityNm : PropTypes.string,
    stAbbrCd : PropTypes.string,
    postCd : PropTypes.string,
    emplrNm : PropTypes.string,
    phoneNumber : PropTypes.string,
    empPh : PropTypes.string,
  }),
  title: PropTypes.string
};

export default BuyerInfo;